/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Fail_RefusalInputs */

const en_import_fail_refusal = /** @type {(inputs: Import_Fail_RefusalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The AI declined this source`)
};

const de_import_fail_refusal = /** @type {(inputs: Import_Fail_RefusalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die KI hat diese Quelle abgelehnt`)
};

/**
* | output |
* | --- |
* | "The AI declined this source" |
*
* @param {Import_Fail_RefusalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_fail_refusal = /** @type {((inputs?: Import_Fail_RefusalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Fail_RefusalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_fail_refusal(inputs)
	return en_import_fail_refusal(inputs)
});